import angular from 'angular';
import frontpageComponent from './frontpage.component';
import "angular-touch";
import "angular-carousel";
import "angular-carousel/dist/angular-carousel.min.css"

let frontpageModule = angular.module('frontpage', ['angular-carousel'])
    .component('frontpage', frontpageComponent)
    .name;

let states = [
    {
        name: 'frontpage',
        url: '/',
        component: 'frontpage',
        title: ''
    },
];

export default {name: frontpageModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/face/index/frontpage/frontpage.js